import { useQuery } from '@tanstack/react-query';

export interface PortalConfigItem {
  chave: string;
  valor: string;
}

/**
 * TEMPORÁRIO — mock local, remover no desenvolvimento do backend. Não existe rota de
 * configuração do portal público na API (`apps/api/src/modulos/` só tem `eu`, `govbr`
 * e `senha`), e a tela precisa existir antes do backend para validação com a
 * SMT/DTP (CLAUDE.md, seção "Proibido", exceção de 2026-08-22). Este mapa some
 * inteiro quando a rota real entrar, e `usePortalConfig` volta a chamar `chamarApi`.
 */
const PORTAL_CONFIG_MOCK: Record<string, string> = {
  footer_descricao:
    'O TEG é o Transporte Escolar Gratuito da Prefeitura de São Paulo, oferecido às famílias com estudantes matriculados na rede municipal de ensino.',
  footer_copyright: '© {ano} Prefeitura de São Paulo. Todos os direitos reservados.',
  footer_lgpd:
    'Os dados informados neste portal são tratados conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).',
  contato_telefone: '156',
  contato_email: 'teg@prefeitura.sp.gov.br',
  contato_endereco: 'Rua Líbero Badaró, 425, Centro, São Paulo, SP',
};

export function usePortalConfig() {
  return useQuery<Record<string, string>>({
    queryKey: ['portal-config'],
    // TEMPORÁRIO — mock local, remover no desenvolvimento do backend.
    queryFn: async () => ({ ...PORTAL_CONFIG_MOCK }),
    staleTime: 10 * 60_000,
  });
}
